// @flow

import { Input } from "antd"
import * as React from "react"

type Props = {
  onChange?: (value: string, isValid: boolean) => void,
  onDebounceChange?: (value: string, isValid: boolean) => void,
  value?: string,
  placeholder?: string,
  autoFocus?: boolean,
  initialCountry?: string,
  setValidState?: Function,
  defaultCountry?: string
}

const PhoneInputFallback = React.forwardRef<Props, any>(
  (
    {
      onChange,
      onDebounceChange: _onDebounceChange,
      value,
      placeholder,
      autoFocus,
      initialCountry: _initialCountry,
      setValidState,
      defaultCountry: _defaultCountry,
      ...props
    }: Props,
    ref
  ) => {
    const handleChange = (e: SyntheticInputEvent<*>) => {
      const phoneValue = e.target.value
      const digitsOnly = phoneValue.replace(/\D/g, "")
      const isValid = digitsOnly.length >= 6

      if (onChange) {
        onChange(phoneValue, isValid)
      }

      if (setValidState) {
        setValidState(isValid)
      }
    }

    return (
      <Input
        {...props}
        ref={ref}
        className="phone-input"
        data-testid="phone-input"
        type="tel"
        placeholder={placeholder || "Phone number"}
        value={value}
        onChange={handleChange}
        autoFocus={autoFocus}
      />
    )
  }
)

PhoneInputFallback.displayName = "PhoneInputFallback"

export default PhoneInputFallback
